import { render, staticRenderFns } from "./DesignationSelect.vue?vue&type=template&id=8f16a3ec"
import script from "./DesignationSelect.vue?vue&type=script&lang=js"
export * from "./DesignationSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports